import { FsTargetingOperator, Targetings } from '@src/application/modules/flagship/type';
import styles from '@src/application/modules/shared/styles/CampaignSummary/CampaignSummary.module.scss';

function getTargetingOperatorColor(operator: FsTargetingOperator) {
  const operatorsNot = [FsTargetingOperator.notEquals, FsTargetingOperator.notContains, FsTargetingOperator.noExists];
  return operatorsNot.includes(operator) ? styles.targetingOperatorRed : styles.targetingOperatorGreen;
}

export const Targeting = ({ targeting, isLastTarget }: { targeting: Targetings; isLastTarget: boolean }) => {
  const renderTargetingOperator = () => {
    if (targeting.key !== 'fs_all_users') {
      return (
        <>
          <span className={`${styles.targetingOperator} ${getTargetingOperatorColor(targeting.operator)}`}>
            {targeting.operator}
          </span>{' '}
          {JSON.stringify(targeting.value)}
        </>
      );
    }
    return null;
  };

  return (
    <span>
      {targeting.key} {renderTargetingOperator()}
      {!isLastTarget && <span className={`${styles.targetingLogicOperator} ${styles.and}`}>AND</span>}
    </span>
  );
};
